import React from 'react';
import styled from 'styled-components';

import {
  LinkedinShareButton,
  WhatsappShareButton,
  FacebookShareButton,
  TwitterShareButton,
} from 'react-share';

import { Heading } from '../elements';

import Facebook from '../../../static/images/social/facebook.inline.svg';
import Twitter from '../../../static/images/social/twitter.inline.svg';
import LinkedIn from '../../../static/images/social/linkedin.inline.svg';
import WhatsApp from '../../../static/images/social/whatsapp.inline.svg';

const BoxedStyled = styled.div`
  background-color: ${(props) => props.theme.mainBrandColor};
`;

const SocialFooter = ({ postUrl, title }) => {
  console.log(postUrl, 'postUrl');
  return (
    <section className="section my-4">
      <div className="container">
        <BoxedStyled className="box">
          <div className="columns is-vcentered">
            <div className="column">
              <Heading className="has-text-centered-mobile">
                Share this article
              </Heading>
            </div>

            <div className="column">
              <div className="columns is-mobile">
                <div className="column is-3">
                  <WhatsappShareButton
                    url={postUrl}
                    quote={title}
                    hashtag="#ecommerce"
                  >
                    <img src={WhatsApp} alt="WhatsApp" />
                  </WhatsappShareButton>
                </div>
                <div className="column is-3">
                  <FacebookShareButton
                    url={postUrl}
                    quote={title}
                    hashtag="#capextax"
                  >
                    <img src={Facebook} alt="Facebook" />
                  </FacebookShareButton>
                </div>

                <div className="column is-3">
                  <TwitterShareButton
                    url={postUrl}
                    title={title}
                    hashtags={['capextax']}
                  >
                    <img src={Twitter} alt="Twitter" />
                  </TwitterShareButton>
                </div>
                <div className="column is-3">
                  <LinkedinShareButton
                    url={postUrl}
                    title={title}
                    hashtags={['ecommerce']}
                  >
                    <img src={LinkedIn} alt="LinkedIn" />
                  </LinkedinShareButton>
                </div>
              </div>
            </div>
          </div>
        </BoxedStyled>
      </div>
    </section>
  );
};

export default SocialFooter;
